export enum CommentLike {
  Like = "Like",
  None = "None"
}
